/**
 * Áreas de trabajo de un proyecto.
 *
 * Estructura mixta: algunos items son items planos, otros son GRUPOS con
 * sub-items (e.g. "Guion" agrupa Editor + Tratamiento+escaleta).
 *
 * El sidebar contextual (`ProjectShell`) renderiza los grupos como encabezado
 * con sus hijos indentados debajo. La Portada los aplana en una lista plana.
 *
 * El campo `key` se sincroniza con el queryparam `?tab=` y con los testids
 * existentes (`tab-dossier`, `tab-screenplay`, etc.) para no romper tests ni
 * marcadores guardados.
 */

const ITEMS = [
  { key: "overview", label: "Portada", icon: "▢",
    description: "Resumen, equipo y acciones rápidas." },
  { key: "dossier", label: "Dossier", icon: "▦",
    description: "Argumento, sinopsis, personajes y plantillas listas para enviar." },
  // Grupo "Guion" — incluye Editor + Tratamiento+escaleta.
  { type: "group", key: "guion", label: "Guion", icon: "✎", children: [
    { key: "screenplay", label: "Editor de guion", icon: "★",
      description: "Edita el guion en formato profesional con asistente IA contextual.",
      accent: true },
    { key: "script", label: "Tratamiento + escaleta", icon: "≡",
      description: "Sube el guion, genera escaleta o tratamiento, distribuye en escenas." },
  ]},
  { key: "casting", label: "Casting", icon: "⌘",
    description: "Análisis IA del guion, fichas de personajes y propuestas de actores." },
  { key: "calendar", label: "Calendario", icon: "◷",
    description: "Desarrollo, financiación, preproducción, rodaje, postpro y festivales." },
  { key: "budget", label: "Presupuesto", icon: "€",
    description: "Presupuesto detallado con validación Cap.11 ≤ 7% y Cap.12 ≤ 20%." },
  { key: "financing", label: "Financiación", icon: "▢",
    description: "Cobertura, fuentes y cálculo del crédito fiscal estatal." },
  { key: "pipeline", label: "Pipeline", icon: "⬚",
    description: "Pipeline Kanban con fondos, broadcasters, mecenas y distribuidores." },
  { key: "notes", label: "Notas / Tareas", icon: "≣",
    description: "Tareas pendientes + notas de voz y texto del proyecto." },
];

/** Default area al abrir `/project/:id`. */
export const DEFAULT_AREA = "overview";

/** Sidebar tree (incluye grupos). */
export const PROJECT_AREA_TREE = ITEMS;

/** Lista plana de todas las áreas hoja (para la Portada y validaciones). */
export const PROJECT_AREAS = ITEMS.flatMap((it) =>
  it.type === "group" ? it.children : [it],
);

/** Set de keys válidas (excluye grupos contenedores). */
export const VALID_AREA_KEYS = new Set(PROJECT_AREAS.map((a) => a.key));

/** Devuelve la metadata de un área (no de grupo). Fallback al default. */
export function areaMeta(key) {
  return PROJECT_AREAS.find((a) => a.key === key) || PROJECT_AREAS[0];
}

/** Devuelve la key del grupo padre si la `key` es hija de un grupo, o null. */
export function parentGroupKey(childKey) {
  const g = ITEMS.find((it) => it.type === "group" && it.children?.some((c) => c.key === childKey));
  return g?.key || null;
}
